import React from 'react';
import { NavLink } from 'react-router-dom';

const EmployeerolesCrumb = () => (
  <NavLink to="/admin/employeeroles">Employee Role Management</NavLink>
);

export default EmployeerolesCrumb;
